import { useState } from 'react';
import { analyticsEnabled, setConsent } from '../../analytics/gtag.js';
import { clearConsent, readConsent } from '../../analytics/consent.js';

/**
 * Withdraws, or re-opens, the analytics answer — from inside the policy that
 * describes it.
 *
 * A policy that says "you can change your mind" and then sends the reader to
 * their browser settings has not really offered it. This is the sentence and
 * the switch in one place.
 *
 * Withdrawing does two things in order, and the order matters: gtag is told
 * `denied` first, so storage stops for the page the reader is on, and only
 * then is the stored answer erased so the banner will ask again. Erasing
 * first would leave a granted gtag running under a forgotten answer until the
 * next navigation.
 *
 * Renders nothing in a build with no measurement id — there is no choice to
 * withdraw when nothing was ever loaded, and an inert button under a sentence
 * about changing your mind is worse than silence.
 */
export function ConsentReset() {
  const [choice, setChoice] = useState(readConsent);

  if (!analyticsEnabled()) return null;

  const withdraw = () => {
    setConsent('denied');
    clearConsent();
    setChoice(undefined);
  };

  if (choice === undefined) {
    return <>You have not answered yet, so nothing is being stored; the banner is still waiting.</>;
  }

  if (choice === 'denied') {
    return <>You have declined, so Google Analytics is storing nothing on this device.</>;
  }

  return (
    <>
      You have accepted on this device.{' '}
      <button type="button" className="secondary" onClick={withdraw}>
        Withdraw consent
      </button>
    </>
  );
}
